import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import '../styles/Header.css';
import logo from '../img/logo-aw.svg';
import { LanguageContext } from '../contexts/LanguageContext';
import { FaBars, FaTimes } from 'react-icons/fa';

const Header: React.FC = () => {
    const { language, toggleLanguage } = useContext(LanguageContext)!;
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const translations = {
        en: {
            projects: "Work",
            services: "Services",
            about: "About",
            contact: "Contact",
        },
        fr: {
            projects: "Projets",
            services: "Services",
            about: "À propos",
            contact: "Contact",
        },
    };

    const linkContact = {
        hover: {
            scale: 1.1,
            rotate: 3,
            boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.3)",
            background: "linear-gradient(135deg, #ff004c, #ff7300, #fffb00)",
            transition: {
                duration: 0.1,
                yoyo: Infinity
            }
        },
        tap: {
            scale: 0.9,
            rotate: -8,
            boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.2)",
            transition: {
                duration: 0.1
            }
        }
    };

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const closeMenu = () => {
        setIsMenuOpen(false);
    };

    return (
        <header className="header">
            <nav className="nav">
                <div className="nav__logo">
                    <Link to="/"><img src={logo} alt="Logo" className="logo" /></Link>
                </div>
                <div className={`menu-icon ${isMenuOpen ? 'open' : ''}`} onClick={toggleMenu}>
                    {isMenuOpen ? <FaTimes size={30} /> : <FaBars size={30} />}
                </div>
                <ul className={`nav__links ${isMenuOpen ? 'open' : ''}`}>
                    {isMenuOpen && (
                        <>
                            <li className="nav__logo-mobile">
                                <Link to="/" onClick={closeMenu}><img src={logo} alt="Logo" className="logo" /></Link>
                            </li>
                        </>
                    )}
                    <li className="navbar-link">
                        <Link to="/projects" onClick={closeMenu} className="link-animated">
                            {translations[language].projects}
                        </Link>
                    </li>
                    <li className="navbar-link">
                        <Link to="/services" onClick={closeMenu} className="link-animated">
                            {translations[language].services}
                        </Link>
                    </li>
                    <li className="navbar-link">
                        <Link to="/about" onClick={closeMenu} className="link-animated">
                            {translations[language].about}
                        </Link>
                    </li>
                    <li className="contact-link">
                        <Link to="/contact" onClick={closeMenu}>
                            <motion.div
                                className="contact-button"
                                variants={linkContact}
                                whileHover="hover"
                                whileTap="tap"
                            >
                                {translations[language].contact}
                            </motion.div>
                        </Link>
                    </li>
                </ul>
            </nav>
            <div className="language-switcher">
                <span
                    className={`language-option ${language === 'en' ? 'active' : ''}`}
                    onClick={toggleLanguage}
                >
                    EN
                </span>
                <span>|</span>
                <span
                    className={`language-option ${language === 'fr' ? 'active' : ''}`}
                    onClick={toggleLanguage}
                >
                    FR
                </span>
            </div>
        </header>
    );
};

export default Header;
